module.exports = __webpack_public_path__ + "static/img/cxsp.a40b21a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cxsp.jpg
// module id = 2npA
// module chunks = 20